import { hydrateRoot } from "react-dom/client";
import App from "./App";
import { AppProviders } from "./AppProviders";
import "./index.css";

hydrateRoot(
  document.getElementById("root")!,
  <AppProviders>
    <App />
  </AppProviders>
);
